import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 9D572A82-B0D2-4961-B467-32AD78FF551C
 * name roman-numeral-4
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/roman-numeral-4.svg
 * tags
 * - Alpha / Numeric 
 */
export const RomanNumeral4Icon = createSvgIcon(<><path d="M12 7L14 17H16L18 7H16L15 12L14 7H12M11 7V9H10V15H11V17H7V15H8V9H7V7H11Z" /></>, 'RomanNumeral4Icon');
export default RomanNumeral4Icon